// ===== PRODUKTSEITE: MAC-Umbau v9 =====
(function () {
  var running = false;
  var panel = null, overlay = null, trigger = null;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function qa(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }
  function safe(fn) { try { fn(); } catch (e) { console.warn('mac-product:', e.message); } }

  function getSizeFs() {
    return qa('.product-form__input, variant-selects fieldset').find(function (fs) {
      var l = fs.querySelector('legend, .form__label');
      return l && /^(size|größe)/i.test(l.textContent.replace(/\s+/g, ' ').trim());
    }) || null;
  }
  function getLaengeFs() {
    return qa('.product-form__input, variant-selects fieldset').find(function (fs) {
      var l = fs.querySelector('legend, .form__label');
      return l && /^(länge|second size)/i.test(l.textContent.replace(/\s+/g, ' ').trim());
    }) || null;
  }

  function apply() {
    if (running) return;
    running = true;
    var info = q('.product__info-container');
    if (!info) { running = false; return; }
    

    // USP-Kacheln
    safe(function () {
      qa(':scope > *', info).forEach(function (el) {
        if (/kostenloser versand ab/i.test(el.textContent) && /retoure/i.test(el.textContent) && !el.querySelector('.product-form__buttons')) {
          el.style.display = 'none';
        }
      });
    });

    // Steuer inline
    safe(function () {
      var priceEl = q('.price', info);
      var taxEl = q('.product__tax', info);
      if (priceEl && !q('.mac-tax', info)) {
        var tax = document.createElement('a');
        tax.className = 'mac-tax';
        tax.href = '/policies/shipping-policy';
        tax.innerHTML = 'inkl. MwSt. zzgl. <u>Versandkosten</u>';
        priceEl.appendChild(tax);
      }
      if (taxEl) taxEl.style.display = 'none';
    });

   

    // Reihenfolge: Größe → Warenkorb+Herz → Anprobe → Lieferzeit
    safe(function () {
      var buttons = q('.product-form__buttons');
      var lieferzeit = q('.mac-lieferzeit');
      var anprobeBtn = qa('button, a', info).find(function (el) { return /virtuelle anprobe/i.test(el.textContent); });
      if (anprobeBtn && buttons) {
        var anprobeBlock = anprobeBtn.closest('.product__info-container > *') || anprobeBtn;
        if (!anprobeBlock.contains(buttons) && anprobeBlock !== buttons && buttons.nextElementSibling !== anprobeBlock) {
          buttons.insertAdjacentElement('afterend', anprobeBlock);
        }
        if (lieferzeit && anprobeBlock.nextElementSibling !== lieferzeit && !anprobeBlock.contains(lieferzeit)) {
          anprobeBlock.insertAdjacentElement('afterend', lieferzeit);
        }
        qa(':scope > *', info).forEach(function (el) {
          if (/schau, wie gut du/i.test(el.textContent) && el !== anprobeBlock && !el.contains(anprobeBlock) && el.children.length < 3) el.style.display = 'none';
        });
      }
    });

    // Labels (Link im Size-Label bleibt erhalten)
    safe(function () {
      qa('.product-form__input, variant-selects fieldset').forEach(function (fs) {
        var legend = fs.querySelector('legend, .form__label');
        if (!legend) return;
        var raw = legend.textContent.replace(/\s+/g, ' ').trim().toLowerCase();
        if (raw.indexOf('color') === 0 || raw.indexOf('farbe') === 0) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          legend.textContent = 'Farbe: ' + (checked ? checked.value : '');
        } else if (raw.indexOf('size') === 0 || raw.indexOf('größe') === 0) {
          legend.childNodes.forEach(function (n) {
            if (n.nodeType === 3) n.textContent = n.textContent.replace(/size/i, 'Größe');
          });
        } else if (raw.indexOf('second size') === 0) {
          legend.childNodes.forEach(function (n) {
            if (n.nodeType === 3) n.textContent = n.textContent.replace(/second size/i, 'Länge');
          });
        }
      });
    });

    setTimeout(function () { running = false; }, 50);
  }

  function boot() {
    apply();
    var section = q('.product__info-wrapper') || q('.product');
    if (section) {
      var debounce = null;
      new MutationObserver(function () {
        if (running) return;
        clearTimeout(debounce);
        debounce = setTimeout(apply, 250);
      }).observe(section, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(boot, 300); });
  } else {
    setTimeout(boot, 300);
  }
  document.addEventListener('shopify:section:load', apply);
})();